// Some stuff is not rendered below our "small" breakpoint
export const SMALL_BREAKPOINT = 400;



// WEBPACK FOOTER //
// ../node_modules/@cube/finance-components/src/components/dynamic-stock-chart/constants.js